import { useEffect, useState } from "react";
import { CalendarRange, Flame } from "lucide-react";
import api from "../../lib/api";
import { Collapsible } from "./bits";

const HEALTH_LABEL = { water: "Water", pushups: "Push-ups", squats: "Squats", leg_raises: "Leg raises", protein: "Protein", meditation: "Meditation" };

export default function WeekReview({ date, tz, onPick, refreshKey }) {
  const [w, setW] = useState(null);
  useEffect(() => { api.get(`/planner/week?date=${date}&tz_offset=${tz}`).then(({ data }) => setW(data)).catch(() => {}); }, [date, tz, refreshKey]);
  const summary = w && <span className="hidden sm:inline">{w.goals_total} goals hit · best health streak {w.best_health_streak}d · {w.topics_total} language topics</span>;
  return (
    <Collapsible title="This Week" icon={CalendarRange} testid="week-review" summary={summary}>
      {!w ? <p className="text-xs text-slate-400">Loading…</p> : (
        <div className="grid grid-cols-7 gap-1.5" data-testid="week-grid">
          {w.days.map((d) => (
            <button key={d.date} onClick={() => onPick(d.date)} className={`text-left rounded-lg border p-2 transition-[background-color,border-color] hover:border-gold ${d.date === date ? "border-gold bg-gold/10" : d.is_today ? "border-navy-800/40" : "border-slate-200"} ${d.future ? "opacity-50" : ""}`} data-testid={`week-day-${d.date}`}>
              <p className="text-[10px] uppercase font-bold text-slate-400">{d.weekday}<span className="ml-1 text-navy-800">{Number(d.date.slice(-2))}</span></p>
              <div className="mt-1 space-y-1 text-[11px] text-navy-800">
                <p><span className="text-slate-400">Goals</span> <b>{d.goals_hit}/3</b> <span className="text-slate-400">· RE</span> <b>{d.re_hit}/3</b></p>
                <p className="flex items-center gap-1"><Flame className={`w-3 h-3 ${d.health_all ? "text-orange-500" : "text-slate-300"}`} /><b>{d.health_hit.length}/6</b>{d.health_streak > 1 && <span className="text-orange-600 text-[10px]">×{d.health_streak}</span>}</p>
                <p className="text-[10px] text-slate-500 break-words leading-tight">{d.health_hit.map((h) => HEALTH_LABEL[h]).join(", ") || "—"}</p>
                <p><span className="text-slate-400">Lang</span> <b>{d.languages.length}</b> <span className="text-slate-400">({d.topics} topics)</span></p>
                <p className="text-[10px] text-slate-500 break-words leading-tight">{d.languages.join(", ") || "—"}</p>
                <p className={`text-[10px] ${d.review_done ? "text-emerald-600" : "text-slate-400"}`}>{d.review_done ? "Review ✓" : "No review"}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </Collapsible>
  );
}
